export const globalFewLeftThreshold = 1;
